import { apiSlice } from "../api-slice";
import { ResetPasswordRequest, UpdateProfileRequest } from "./user-api-request";
import { DepartmentUsersResponse, ResetPasswordResponse, UpdateProfileResponse, UserInfo, UserInfoResponse } from "./user-api-state";

export type departmentTypesForApi = 'EBAM' | 'GMS' | 'ACTUARIAL' | 'IT'

export const userAPI = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserInfo: builder.query<UserInfo, { userId: number }>({
            query: ({ userId }) => `api/user/${userId}`,
            transformResponse: (response: UserInfoResponse) => response.user,
            transformErrorResponse: (response: any) => response,
            providesTags: (result, error, { userId }) => [
                { type: "User", id: userId },
                { type: 'User', id: 'LIST' },
            ],
        }),
        updateProfile: builder.mutation<UpdateProfileResponse, UpdateProfileRequest>({
            query: (body) => ({
                url: '/api/user/update-profile',
                method: 'PUT',
                body,
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: [
                { type: "User", id: "LIST" },
                { type: "Proposal", id: "LIST" },
            ],
        }),
        resetPassword: builder.mutation<ResetPasswordResponse, ResetPasswordRequest>({
            query: (body) => ({
                url: '/api/user/reset-password',
                method: 'PUT',
                body,
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: [
                { type: "User", id: "LIST" },
            ],
        }),
        // http://localhost:5000/api/financial-insurance/department/IT
        getAllUserDepartment: builder.query<DepartmentUsersResponse, { type: departmentTypesForApi }>({
            query: ({ type }) => `api/financial-insurance/department/${type}`,
            transformResponse: (response: DepartmentUsersResponse) => response,
            transformErrorResponse: (response: any) => response,
            // providesTags: (result, error, { userId }) => [
            //     { type: "User", id: userId },
            //     { type: 'User', id: 'LIST' },
            // ],
        }),
    }),
});

export const { 
    useGetUserInfoQuery,
    useUpdateProfileMutation,
    useResetPasswordMutation,
    useGetAllUserDepartmentQuery,
} = userAPI;